import {useEffect, useRef} from 'react';

export function useScrollOnReveal(revealCondition: boolean) {
  const ref = useRef<HTMLDivElement>(null);
  const hasScrolled = useRef(false);

  useEffect(() => {
    if (revealCondition && ref.current && !hasScrolled.current) {
      // small delay ensures the DOM is fully painted
      const timer = setTimeout(() => {
        ref.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center', // or 'nearest', 'start'
        });
        hasScrolled.current = true;
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [revealCondition]);

  return ref;
}
